import { useTranslation } from 'react-i18next';
import { FormFileList, FormFileListProps } from '..';
import { usePersonalPropertyItemFormContext } from '../../PersonalPropertyItem/context';

interface PersonalPropertyItemFileListProps extends Pick<FormFileListProps, 'className' | 'withTitle'> {}

export function PersonalPropertyItemFileList(props: PersonalPropertyItemFileListProps) {
  const { t: tForm } = useTranslation('form');
  const { householdID, personalPropertyItem } = usePersonalPropertyItemFormContext();

  return (
    <FormFileList
      {...props}
      tenantID={householdID}
      itemID={personalPropertyItem?.id}
      title={tForm('general-related-documents')}
    />
  );
}
